export const reduxKey = '@@publicSession';
export const actionKey = '@@publicSession';
